<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="text-h5 blue darken-3 white--text">
          Cambiar estado de la inscripcion
        </v-card-title>

        <v-card-text>
          <v-divider></v-divider>
          <v-radio-group v-model="xestado" class="text-center">
            <v-radio v-for="n in xestados" :key="n.id" :label="n.text" :value="n"></v-radio>
          </v-radio-group>
          <p class="text-center red--text">{{ msg }}</p>
          <v-divider></v-divider>
          <v-progress-linear v-if="loading" indeterminate color="indigo"></v-progress-linear>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="enviar()" :disabled="loading">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        // preinscrito/inscrito/cambiado/retirado
        idins: null,
        xestado: null,
        xestados: [
          { id: 0, text: 'preinscrito' },
          { id: 1, text: 'inscrito' },
          { id: 2, text: 'retirado' },
          { id: 3, text: 'cambiado' },
        ],
        msg: '',
      };
    },
    methods: {
      openmodal(inscripcion) {
        // window.console.log(inscripcion, xaxios);
        this.idins = inscripcion.id;
        this.dialog = true;
      },
      enviar() {
        this.msg = '';
        if (!this.xestado) {
          this.msg = 'Selecciona un estado para cambiar...';
          return;
        }

        this.loading = true;
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${this.idins}/estado_ins`;
        let data = { estado_ins: this.xestado.id };
        xaxios
          .patch(url, data)
          .then((res) => {
            window.console.log(res);
            vue.msg = res.data.data;
            vue.loading = false;
          })
          .catch((error) => {
            window.console.error(error);
            vue.msg = error;
            vue.loading = false;
          });
      },
    },
  };
</script>
